module.exports = __webpack_public_path__ + "static/media/admission_tab.63c9326f.png";